import { preCachePreferences } from '@fs/zion-preferences'

// Preload all noteworthy preferences that are used by the app and multiple sub-components to speed up pageloads.
export default function usePreloadPreferences() {
  preCachePreferences(
    'help-tutorial.show-ad-prefs',
    'private.direction',
    'private.sort',
    'tree.cetTest',
    // 'tree.defaultPedigreeView', // Only when no specific pedigree is chosen, but always triggers a simultaneous PUT+GET
    'tree.fgtTest',
    'tree.firstAncestor.fa.added.by.user',
    'tree.groups.startingPersonId',
    'tree.lastViewedPid',
    'tree.ONBOARDED',
    'tree.showLDSTempleInfo',
    'tree.showNamesInRomanScript',
    'tree.startingPersonId',
    'tree.view-options',
    'tree.showMyPrivateTreeOverlay'
  )
}
